import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'
import { useStateValue } from '@State'
import { ltiOrgKeyManagement as endpoints } from '@URLS'

export const ResetNameDomainModal = props => {
  const [currentState, dispatch] = useStateValue()

  const reset = async () => {
    try {
      await client.post(endpoints.resetOrg(), { orgId: props.orgId })
      toast.success("Successfully reset organization name and domain.")
      // Trigger the lower components useEffect hook
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
    } catch (err) {
      console.log(err)
      toast.error("There was an error trying to reset the name and domain.")
    } finally {
      props.toggle(!props.show)
    }
  }

  return (
    <Modal show={props.show} onHide={() => props.toggle(!props.show)}>
      <Modal.Header closeButton>
        <Modal.Title>Reset Name and Domain</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>Reset name and domain of organization?</h5>
        <div
          className="btn btn-danger btn-myed btn-danger-myed"
          onClick={() => reset()}
        >
          <div className="fa-regular fa-times fa-fw mr-2" /> Reset
        </div>
      </Modal.Body>
    </Modal>
  )
}

ResetNameDomainModal.propTypes = {
  orgId: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}
